import script from "./ModernAgentTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ModernAgentTable.vue?vue&type=script&setup=true&lang=js"

import "./ModernAgentTable.vue?vue&type=style&index=0&id=d1d5e2da&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1d5e2da"]])

export default __exports__